


(function() {
  
  /**
   * PARALLAX & ANIMATIONS
   */
  let isHome = document.getElementById('matthiaskrueger');
  let isHomeEN = document.getElementById('matthiaskrueger-en');
  
   // check if root directory, if not exit!
   
  //  console.log(location.pathname);

   
    
  //  console.log(navigator.userAgent)
  // if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    if(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    // true for mobile device
    //console.log("mobile device");

  }else{
    // false for not mobile device
    // console.log("not mobile device");

    if(isHome|| isHomeEN){
      var rellax = new Rellax('.bg-image', {
        speed: -6,
        center: true,
        wrapper: null,
        round: false,
        vertical: true,
        horizontal: false,
        
      });
    }
    

    /**
     * Icon Animation
     */


    //check if we are in home
    
    

    if(isHome){
      gsap.set('.icon-bar', {
        opacity: 0
      })
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#intro",
          start: "top+=110% top+=50%",
          end: "bottom top",
          scrub: true,
          // markers: true
        }
      });
    
      tl
      .to('.icon-bar', { opacity: 1, duration: 0.5 })

      const t2 = gsap.timeline({
        scrollTrigger: {
          trigger: "#kontakt",
          start: "top+=80% top+=50%",
          end: "bottom-=30% top",
          scrub: true,
          // pin: true,
          // markers: true
        }
      });
      t2.to('.icon-bar', { opacity: 0, duration: 0.5 })

      const t3 = gsap.timeline({
        scrollTrigger: {
          trigger: "#colophon",
          start: "top-=100% top+=50%",
          end: "bottom-=200% top",
          scrub: true,
          // markers: true
        }
      });
      t3.to('.icon-bar', { opacity: 0, duration: 0.2 })
    }

    if(isHomeEN){
      gsap.set('.icon-bar', {
        opacity: 0
      })
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#intro-en",
          start: "top+=110% top+=50%",
          end: "bottom top",
          scrub: true,
          // markers: true
        }
      });
    
      tl
      .to('.icon-bar', { opacity: 1, duration: 0.5 })

      const t2 = gsap.timeline({
        scrollTrigger: {
          trigger: "#contact",
          start: "top+=80% top+=50%",
          end: "bottom-=30% top",
          scrub: true,
          // pin: true,
          // markers: true
        }
      });
      t2.to('.icon-bar', { opacity: 0, duration: 0.5 })

      const t3 = gsap.timeline({
        scrollTrigger: {
          trigger: "#colophon",
          start: "top-=100% top+=50%",
          end: "bottom-=200% top",
          scrub: true,
          // markers: true
        }
      });
      t3.to('.icon-bar', { opacity: 0, duration: 0.2 })
    }
    
    

   


    const t4 = gsap.timeline({
      scrollTrigger: {
        trigger: "#colophon",
        start: "top bottom",
        end: "center bottom",
        scrub: true,
        // markers: true
      }
    });
    t4.to('.icon-bar', { opacity: 0, duration: 0.2 })


    
  }

  

   if(!window.isMobile.any()){
     // console.log("MOBILE")
    
  }

  /**
   * Shrink Navbar
   */

  window.onscroll = async () => {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      document.querySelector('nav').classList.add("shrink");
    } else {
      document.querySelector('nav').classList.remove("shrink");
    }
  };

  /**
   * ANCHOR SCROLL
   */

  

  let all_anchors = document.querySelectorAll('a.nav-link[href^="#"]');

  for(let anchor of all_anchors){
    
    anchor.addEventListener("click", function(e){
      e.preventDefault();
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') 
                && location.hostname == this.hostname) {


        var target =  document.getElementById(this.hash.slice(1))
        if (target) {

          doScrolling( target.offsetTop -50, 1000);
          return false;
        }
      }
    });

    // position observerbles

    var anchor_with_hash = anchor.getAttribute("href");

    let options = {
      rootMargin: '50% 0px -50% 0px',
      // threshold: [.2, .9]
    }
    const myImg = document.querySelector(anchor_with_hash);

    observer = new IntersectionObserver(entries => {
      // console.log(isAnimation);
      // current_id = entries[0];
      if(entries[0].isIntersecting){

        window.requestAnimationFrame(function step(timestamp){

          document.querySelector('a.nav-link[href^="#'+ entries[0].target.id + '"]').classList.add("active");

          current_id = entries[0].target.id;

          // if(history.pushState) {
          //   history.pushState(null, null, '#'+ entries[0].target.id);
          // }
          // else {// old browsers
          //     location.hash = '#' + entries[0].target.id;
          // }
         
        })
      }
      else {
        document.querySelector('a.nav-link[href^="#'+ entries[0].target.id + '"]').classList.remove("active");
      }

    }, options);

    observer.observe(myImg);
    
  }

  // actual scrolling with rAF method!
  async function doScrolling(elementY, duration) { 
    // console.log("scrolling", elementY)
    var startingY = window.pageYOffset;
    var diff = elementY - startingY;
    var start;
  
    // Bootstrap our animation - it will get called right before next frame shall be rendered.
    window.requestAnimationFrame(function step(timestamp) {
      isAnimation = true;
      if (!start) start = timestamp;
      // Elapsed milliseconds since start of scrolling.
      var time = timestamp - start;
      // Get percent of completion in range [0, 1].
      var percent = Math.min(time / duration, 1);
  
      window.scrollTo(0, startingY + diff * percent);
  
      // Proceed with animation as long as we wanted it to.
      if (time < duration) {
        window.requestAnimationFrame(step);
      }
      
    })
  }
}());

